import {
  PRICE_TYPE_LEASE_ATTRIBUTE_VALUE_ID,
  PRICE_TYPE_SALE_ATTRIBUTE_VALUE_ID,
} from '@/constants/attributes/nonStandards';

const MIN_PRICE_TYPE_COUNT = 2;

// Detect presence of both price type ids (represents "All")
const hasBothPriceTypes = (attrs: Array<{ attributeValueId: number | string }> | undefined): boolean => {
  if (!Array.isArray(attrs) || attrs.length < MIN_PRICE_TYPE_COUNT) return false;
  let hasSale = false;
  let hasLease = false;
  for (const a of attrs) {
    const idNum = Number(a.attributeValueId);
    if (idNum === PRICE_TYPE_SALE_ATTRIBUTE_VALUE_ID) hasSale = true;
    else if (idNum === PRICE_TYPE_LEASE_ATTRIBUTE_VALUE_ID) hasLease = true;
    if (hasSale && hasLease) return true;
  }
  return false;
};

export default hasBothPriceTypes;
